import { SxProps } from '@mui/material';

export const inputBaseStyles: SxProps = {
  '& .MuiOutlinedInput-root': {
    height: '31px',
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    '& fieldset': {
      border: '1px solid #D0D5DD',
    },
    '&:hover fieldset': {
      border: '1px solid #D0D5DD',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid #6941C6',
      borderWidth: '1px',
    },
    '& .MuiInputAdornment-root': {
      '& .MuiSvgIcon-root': {
        color: '#667085',
        width: '16px !important',
        height: '16px !important',
        fontSize: '20px',
      },
    },
  },
  '& .MuiInputLabel-root': {
    color: '#344054',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '20px',
    '&.Mui-focused': {
      color: '#344054',
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: '10px 14px',
    fontSize: '15px',
    color: '#000000',
    fontWeight: 500,
    verticalAlign: 'middle',
    fontFamily: 'Inter',
    '&::placeholder': {
      color: '#00000066',
      opacity: 1,
      fontSize: '15px',
      fontWeight: 500,
      verticalAlign: 'middle',
      fontFamily: 'Inter',
    },
  },
  '& .MuiFormHelperText-root': {
    color: '#F04438',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '20px',
  },
  '& .MuiSelect-select': {
    fontSize: '12px',
    textAlign: 'left',
    fontWeight: 500,
    color: '#000000',
    verticalAlign: 'middle',
  },
  '& .MuiSelect-icon': {
    width: '16px !important',
    height: '16px !important',
    top: 'calc(50% - 8px) !important',
    right: '8px !important'
  },
};

export const helperTextStyles: SxProps = {
  marginLeft: '0',
  fontSize: '12px',
  color: '#E90000',
};

export const requiredAsteriskStyles: SxProps = {
  '& .MuiFormLabel-asterisk': {
    color: '#F04438',
  },
};

export const asyncAutocompleteStyles: SxProps = {
  '& .MuiAutocomplete-popupIndicator': {
    width: '16px !important',
    height: '16px !important',
    color: '#00000066 !important',
    '&.MuiAutocomplete-popupIndicatorOpen': {
      transform: 'rotate(180deg) !important',
    }
  },
  '& .MuiAutocomplete-input': {
    textAlign: 'left',
    fontSize: '12px !important',
    height: '31px !important',
  },
  '& .MuiAutocomplete-option': {
    fontSize: '5px !important',
    color: 'red !important'
  },
  '& .MuiAutocomplete-loading': {
    fontSize: '11px !important',
  },
  '& .MuiAutocomplete-listbox': {
    fontSize: '12px !important',
    padding: '8px 14px',
  },
};
